import { Member } from '@tribeplatform/gql-client/types'
import { useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { MemberAvatar } from '../../common/components/index.js'
import { T } from '../../i18n/index.js'
import { Link } from '../../Link/index.js'

import { Section } from './Section.js'

interface Props {
  hosts: Member[]
}

export const HostedBy = ({ hosts }: Props) => {
  const { generateMemberPath } = useSpaceUtil()

  if (!hosts?.length) {
    return null
  }

  return (
    <Section title={<T id="Event.OrganizedBy" defaultMessage="Organized by" />}>
      <div className="flex flex-col gap-1">
        {hosts.map(host => {
          return (
            <Link
              key={host.id}
              href={generateMemberPath(host)}
              target="_blank"
              className="flex items-center gap-x-2"
            >
              <MemberAvatar member={host} size="2x" />
              <Text className="text-sm text-content-subdued">{host.name}</Text>
            </Link>
          )
        })}
      </div>
    </Section>
  )
}
